export default __webpack_public_path__ + "static/media/process4.9dc09d3e.png";